import React from 'react'
import {SingleDatePicker} from 'react-dates'
import moment from 'moment'

const DateSelectField = props => {
	const {
		configData,
		restaurantKey,
		reservationDate,
		reservationDateFocused,
		handleReservationDateFocus,
		handleReservationDate
	} = props

	const hotelLabels = configData.hotel.labels[0]

	return (
		<div className="u-form-col u-form-col--xl bk-flow-restaurants__form-date">
			<label
				className="u-form-label"
				id={ 'restaurantDateLabel-' + restaurantKey }
				htmlFor={ 'restaurantTime-' + restaurantKey }
			>
				{ hotelLabels && hotelLabels.date ? hotelLabels.date : 'Date' }
			</label>
			<SingleDatePicker
				displayFormat='YYYY-MM-DD'
				numberOfMonths={ 1 }
				daySize={ 33 }
				date={ moment(reservationDate) }
				onDateChange={date => handleReservationDate(date)}
				focused={ reservationDateFocused }
				onFocusChange={({ focused }) => handleReservationDateFocus({ focused })}
				id={ 'restaurantDate-' + restaurantKey }
				openDirection="up"
				navPrev={ <i className="material-icons">arrow_left</i> }
				navNext={ <i className="material-icons">arrow_right</i> }
				noBorder={ true }
			/>
		</div>
	)
}

export default DateSelectField



// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/elements/DateSelectField.js